import { h } from 'preact'; /** @jsx h */
import { useEffect, useState } from 'preact/hooks';

import SavedUserInfo from '../SavedUserInfo/SavedUserInfo';
// import UserInput from '../UserInput/UserInput';

import './UserInfo.scss';

const UserInfo = ({ user, setUser, isReciept = false, emailError }) => {
    // States
    const [editView] = useState(false);
    const [errors, setErrors] = useState({});

    // check if editview is true and disable checkout button if it is
    useEffect(() => {
        const checkoutBtn = document?.querySelector('.ws-order-btn');

        if (!checkoutBtn) {
            return;
        }
        if (editView) {
            checkoutBtn.disabled = true;
        } else {
            checkoutBtn.disabled = false;
        }
    }, [editView]);

    useEffect(() => {
        if (emailError) {
            setErrors({ ho_epost: 'E-post er påkrevd.' });
        }
    }, [emailError]);

    // // Handle edit/save button click
    // const handleSaveClick = () => {
    //     if (editView) {
    //         // Check if required fields are filled out
    //         const newErrors = {};

    //         if (!user?.ho_fnavn) {
    //             newErrors.ho_fnavn = 'Fornavn er påkrevd';
    //         }

    //         if (!user?.ho_enavn) {
    //             newErrors.ho_enavn = 'Etternavn er påkrevd';
    //         }

    //         if (!user?.adresse1) {
    //             newErrors.adresse1 = 'Adresse er påkrevd';
    //         }

    //         if (!user?.postnr) {
    //             newErrors.postnr = 'Postnummer er påkrevd';
    //         }

    //         if (!user?.poststed) {
    //             newErrors.poststed = 'Poststed er påkrevd';
    //         }

    //         if (!user?.ho_epost) {
    //             newErrors.ho_epost = 'E-post er påkrevd';
    //         }

    //         // Email validation
    //         const emailRegex = /\S+@\S+\.\S+/;
    //         if (user?.ho_epost && !emailRegex.test(user?.ho_epost)) {
    //             newErrors.ho_epost = 'E-post er ikke gyldig';
    //         }

    //         // If there are errors, set them and stop here
    //         setErrors(newErrors);
    //         if (Object.keys(newErrors).length > 0) {
    //             return;
    //         }

    //         // If there are no errors, save the user to local storage
    //         localStorage.setItem('snla-user', JSON.stringify(user));
    //     }

    //     setEditView(!editView);
    // };

    // const handleInputChange = event => {
    //     const { name, value } = event.target;
    //     setUser(prevUser => ({ ...prevUser, [name]: value }));
    // };

    return (
        <div className="ws-order-user-info">
            <div className="user-info-header action">
                <div className="header-content">
                    <span className="header-number">1</span>
                    <h6 className="header-title">Leveringsopplysninger</h6>
                </div>
                {/* {!isReciept && (
                    <div className="header-action">
                        <button className="ws-change-info-btn" onClick={handleSaveClick}>
                            {editView ? 'Lagre' : 'Endre'}
                        </button>
                    </div>
                )} */}
            </div>
            {/* {editView ? (
                <UserInput user={user} handleInputChange={handleInputChange} errors={errors} />
            ) : (
                <SavedUserInfo user={user} setUser={setUser} errors={errors} />
            )} */}
            <SavedUserInfo user={user} setUser={setUser} errors={errors} setErrors={setErrors} />
        </div>
    );
};

export default UserInfo;
